<template>
	<vxe-modal :loading="loading" title="波动明细" v-model="modal" @show="show" @hide="hide" width="800" height="600" show-footer destroy-on-close >
		<template #default>
			<div class="full" style="box-sizing: border-box;padding: 10px;">
				<vxe-grid v-bind="gridOptions" v-if="gridOptions" :loading="loading" ref="wlnpurchaseDetail" @toolbar-button-click="toolbarButtonClickEvent"></vxe-grid>
			</div>
		</template>
		<template #footer>
			<vxe-button size="mini" status="" content="返回" @click="modalHide"></vxe-button>
		</template>
	</vxe-modal>

</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			tableData: {
				default: () => {
					return []
				}
			},
			// ordertypeMap: {
			// 	type: Object,
			// 	default: () => {
			// 		return {}
			// 	}
			// },
			// currentRow: {
			// 	default: () => {
			// 		return null
			// 	}
			// },
		},
		data() {
			return {
				modal: false,
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {
			

		},
		methods: {
			getOption() {
				return {
					id: 'purchaseDetail',
					border: true,
					data:this.tableData,
					size: 'mini',
					columns: this.getColumns(),
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					cellStyle:this.cellStyle,
					toolbarConfig: {
						size: 'mini',
						perfect: false,
						buttons: this.toolbarButton,
						customConfig: {
							storage: true
						},
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: 'auto',
					sortConfig: {
						remote: false
					}
				}
			},
			getColumns() {
				return [{
					type: 'eq',
					width: 6
				}, {
					field: 'code',
					title: '商品编码',
				}, {
					field: 'name',
					title: '商品名称',
				}, {
					field: 'size',
					title: '数量',
				}, {
					field: 'price',
					title: '采购单价'
				}, {
					field: 'cost',
					title: '系统单价'
				}, {
					field: 'percent',
					title: '波动',
					formatter:({row})=>{
						return ((row.price - row.cost)/row.cost*100).toFixed(2)
					},
				}]
			},
			modalShow() {
				this.modal = true
			},
			modalHide() {
				this.modal = false
			},
			show() {
				this.gridOptions = this.getOption()
			},
			hide() {

			},
			toolbarButtonClickEvent(){
				
			},
			cellStyle({
				row,
				column
			}) {
				if (row.grabstatus == 8113) {
					return {
						backgroundColor: 'rgb(233, 233, 235)'
					}
				}
				if (column.field == 'status') {
					if (row.status == 0) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.status == 1) {
						return {
							color: '#409EFF'
						}
					}
					if (row.status == 2) {
						return {
							color: '#67C23A'
						}
					}
				}
				if (column.field == 'takeStatus') {
					if (row.takeStatus == 0) {
						return {
							color: '#F56C6C'
						}
					}else  {
						return {
							color: '#67C23A'
						}
					}
				}
			},
		},
		components: {
			
		}
	}
</script>